import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Connection, ConnectionOptions, DataSourceOptions, Repository, createConnection, getConnection } from 'typeorm';
import { LineEntity } from '../../entities/line.entity';

@Injectable()
export class ShahiDbConnectionsService {
    private dbConnMap: Map<string, Map<string, {host: string, uname: string, password: string, port: number}>>;
    constructor(
        @InjectRepository(LineEntity) private lineEnt: Repository<LineEntity>,
        @InjectRepository(LineEntity) private unitEnt: Repository<LineEntity>,
    ) { 
        this.dbConnMap = new Map<string, Map<string, {host: string, uname: string, password: string, port: number}>>();
        this.initializeDbConfigs();
    }

    async initializeDbConfigs(): Promise<boolean>{
        const units = await this.unitEnt.find({ select: ['unitId'], where: {isActive: true}});
        for(const unit of units) {
            const unitId = unit.unitId;
            const lines = await this.lineEnt.find({ select:['lineId', 'dbHost', 'dbUsername', 'dbPassword', 'port'], where: { unitId: unitId }});
            lines.forEach(r => {
                if(!this.dbConnMap.has(unitId)) {
                    this.dbConnMap.set(unitId, new Map<string, {host: string, uname: string, password: string, port: number}>());
                }
                this.dbConnMap.get(unitId).set(r.lineId, { host: r.dbHost, uname: r.dbUsername, password: r.dbPassword, port: r.port })
            });
        }
        return true;
    }

    async getLocalDbConn(): Promise<Connection> {
        const connName = 'some';
        const db = "192.168.3.101";
        const connectionString: DataSourceOptions = {
            type: 'mssql',
            host: db,
            // host: 'localhost',
            port: 1433,
            username: 'sa',
            password: 'ina',
            synchronize: false,
            database: 'IHS',
            extra: {
                validateConnection: true,
                trustServerCertificate: true,
            },
        }
        let connection;
        try {
            connection = getConnection(connName);
            if (!connection?.isConnected) {
                throw null;
            }
            console.log('SHAHI CONNECTION STARTED',connection?.isConnected)
        } catch (error) {
            connection = await createConnection(connectionString);
            console.log('SHAHI CONNECTION STARTED',connection?.isConnected)
        }
        return connection;
    }

    async getShahiDbConnectionForLineAndUnit(dbName: string, unitId: string, lineId: string): Promise<Connection> {
        const connName = 'SHAHI-'+unitId+'-'+dbName+'-'+lineId;
        // const dbInfo = "192.168.3.101";
        const dbInfo = this.dbConnMap.get(unitId).get(lineId);
        // console.log(connName);
        // console.log(dbInfo);
        // throw null;
        const connectionString: ConnectionOptions = {
            type: 'mssql',
            host: `${dbInfo.host}`,
            port: dbInfo.port,
            username: `${dbInfo.uname}`,
            password: `${dbInfo.password}`,
            synchronize: false,
            database: dbName,
            name: connName,
            extra: {
                validateConnection: false,
                trustServerCertificate: true,
            },
            options: {
                cryptoCredentialsDetails: {
                  minVersion: "TLSv1",
                },
                encrypt: false
            }
        }
        let connection;
        try {
            connection = getConnection(connName);
            if (!connection?.isConnected) {
                throw null;
            }
            // console.log('SHAHI CONNECTION STARTED',connection?.isConnected);
        } catch (error) {
            connection = await createConnection(connectionString);
            // console.log('SHAHI CONNECTION STARTED',connection?.isConnected);
        }
        return connection;
    }

    async closeConnectionForUnit(connName: string) {
        return true;
        try {
            const connection = await getConnection(connName);
            await connection.close();
            return true;
        } catch (error) {
            return false;
        }
    }
}
